import useCourse from '../Hooks/useCourse';
import useSections from '../Hooks/useSections';
import { Alert, Box, Divider, Stack, Typography } from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';
import { useMemo, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { Download } from '@mui/icons-material';
import API from "../../../services/API";
import { txt } from "../../../services/translation";

export default function Notes(){

    const course = useCourse();
    
    const sections = useSections();

    const exist = useMemo(() => 
        sections.filter(s => s.note ? true : false).length > 0
    , [sections])


    if(!exist){
        return <Alert severity='info'>{txt('noNotesTaken')} 😌</Alert>

    }


    return <Stack spacing={2}>
            
        <DownloadButton courseId={course.id} />

        <Stack spacing={2} sx={{pl: 1, pr: 1}}>

            {course.chapters
                .filter(c => c.sections.filter(s => s.note ? true : false).length )
                .map(c => 
                    <Chapter chapter={c} key={c.id}/>    
                )}

        </Stack>

    </Stack>
}


function Chapter({chapter}){

    return <>

        <Typography><b>{chapter.title}</b></Typography>

        <Divider />

        {chapter.sections
            .filter(s => s.note ? true : false)
            .map(s =>
                <Section section={s} key={s.id}/>    
            )}

        
    </>
}



function Section({section}){

    return <>

        <Typography>{section.title}</Typography>

        <Alert severity='info' icon={<NotesIcon fontSize='inherit'/>}>
            {section.note}
        </Alert>
    
    </>

}


function DownloadButton({courseId}){

    const [loading, setLoading] = useState(false)

    const handleClick = () => {

        setLoading(true)

        API.download(`/study/courses/${courseId}/notes.pdf`)
            .finally(() => setLoading(false))
    }

    return <Box>

        <LoadingButton
            onClick={handleClick}
            loading={loading}
            startIcon={<Download />}
        >
            {txt('downloadAsPDF')}
        </LoadingButton>

        
    </Box>
}